class SoieCountdown extends HTMLElement {
  connectedCallback() {
    const mode = this.dataset.mode || 'evergreen';
    const hours = Number(this.dataset.hours || 2);
    const key = `soie-countdown-${this.dataset.id || 'store'}-${hours}h`;
    let end;
    if (mode === 'date' && this.dataset.end) end = new Date(this.dataset.end).getTime();
    else {
      end = Number(localStorage.getItem(key));
      if (!end || end < Date.now()) {
        end = Date.now() + hours * 3600000;
        localStorage.setItem(key, String(end));
      }
    }
    const tick = () => {
      let distance = Math.max(0, end - Date.now());
      const days = Math.floor(distance / 86400000); distance %= 86400000;
      const values = [days, Math.floor(distance / 3600000), Math.floor((distance % 3600000) / 60000), Math.floor((distance % 60000) / 1000)];
      this.querySelectorAll('[data-count]').forEach((el, index) => { el.textContent = String(values[index]).padStart(2, '0'); });
      if (end > Date.now()) this.timer = setTimeout(tick, 1000);
    };
    tick();
  }
  disconnectedCallback() { clearTimeout(this.timer); }
}
if (!customElements.get('soie-countdown')) customElements.define('soie-countdown', SoieCountdown);

const reveal = new IntersectionObserver((entries) => entries.forEach((entry) => {
  if (entry.isIntersecting) { entry.target.classList.add('is-visible'); reveal.unobserve(entry.target); }
}), { threshold: .12 });
document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('[data-soie-reveal]').forEach((el) => reveal.observe(el)));
document.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('[data-soie-offer-popup]');
  if (!popup || sessionStorage.getItem('soie-2h-offer-popup-shown') === '1') return;
  window.setTimeout(() => { popup.hidden = false; requestAnimationFrame(() => popup.classList.add('is-open')); }, 1200);
});
document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-soie-reveal]').forEach((el) => reveal.observe(el)));
document.addEventListener('click', (event) => {
  const popupClose = event.target.closest('[data-soie-offer-close]');
  if (popupClose) {
    const popup = popupClose.closest('[data-soie-offer-popup]');
    popup?.classList.remove('is-open');
    sessionStorage.setItem('soie-2h-offer-popup-shown', '1');
    window.setTimeout(() => { if (popup) popup.hidden = true; }, 300);
    return;
  }
  const option = event.target.closest('[data-soie-bundle-option]');
  if (!option) return;
  const bundle = option.closest('.sb');
  bundle?.querySelectorAll('[data-soie-bundle-option]').forEach((item) => item.classList.toggle('is-selected', item === option));
  const details = option.closest('.product-details') || document.querySelector('[data-template*="product"] .product-details');
  const quantity = details?.querySelector('input[name="quantity"]');
  if (quantity) {
    quantity.value = option.dataset.quantity || '1';
    quantity.dispatchEvent(new Event('input', { bubbles: true }));
    quantity.dispatchEvent(new Event('change', { bubbles: true }));
  }
  const priceBlock = details?.querySelector('product-price [ref="priceContainer"]');
  if (priceBlock) {
    const salePrice = priceBlock.querySelector('.price');
    const comparePrice = priceBlock.querySelector('.compare-at-price');
    if (salePrice && option.dataset.salePrice) salePrice.textContent = option.dataset.salePrice;
    if (comparePrice) {
      comparePrice.textContent = option.dataset.comparePrice || '';
      const compareGroup = comparePrice.closest('[role="group"]');
      if (compareGroup) compareGroup.hidden = !option.dataset.comparePrice;
    }
  }
});

function initSoieMediaPin(root = document) {
  const media = root.querySelector?.('[data-template*="product"] .product-information__media') || document.querySelector('[data-template*="product"] .product-information__media');
  const grid = media?.closest('.product-information__grid');
  if (!media || !grid || media.dataset.soiePinReady === 'true') return;
  media.dataset.soiePinReady = 'true';
  media.classList.add('soie-media-pin');
  let frame = 0;
  const update = () => {
    frame = 0;
    if (window.innerWidth < 750) { media.style.setProperty('--soie-media-pin-y', '0px'); return; }
    const gridTop = grid.getBoundingClientRect().top + window.scrollY;
    const gridHeight = grid.offsetHeight;
    const mediaHeight = media.offsetHeight;
    const header = document.querySelector('#header-component');
    const topOffset = (header?.offsetHeight || 90) + 16;
    const wanted = window.scrollY + topOffset - gridTop;
    const max = Math.max(0, gridHeight - mediaHeight);
    media.style.setProperty('--soie-media-pin-y', `${Math.max(0, Math.min(wanted, max))}px`);
  };
  const requestUpdate = () => { if (!frame) frame = requestAnimationFrame(update); };
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  new ResizeObserver(requestUpdate).observe(grid);
  requestUpdate();
}
document.addEventListener('DOMContentLoaded', () => initSoieMediaPin());
document.addEventListener('shopify:section:load', (event) => initSoieMediaPin(event.target));
document.addEventListener('shopify:section:load', () => refreshBundlerQuantityBreakCache());

let soieBundlerQuantityBreakCache = null;

function hasBundlerQuantityBreak(root = document) {
  const candidates = root.querySelectorAll('h1,h2,h3,h4,p,span,div');
  for (const element of candidates) {
    const text = element.textContent?.trim().toLowerCase();
    if (text === 'buy in bulk and get a discount!' || text === 'buy 2 and get a discount!') return true;
  }
  return false;
}

function refreshBundlerQuantityBreakCache(root = document) {
  soieBundlerQuantityBreakCache = hasBundlerQuantityBreak(root);
}

function lockSoieUnitPrice() {
  if (soieBundlerQuantityBreakCache === null) refreshBundlerQuantityBreakCache();
  if (!soieBundlerQuantityBreakCache) return;
  document.querySelectorAll('product-price[data-soie-unit-price]').forEach((priceBlock) => {
    const container = priceBlock.querySelector('[ref="priceContainer"]');
    const price = container?.querySelector('.price');
    const compare = container?.querySelector('.compare-at-price');
    if (price && price.textContent.trim() !== priceBlock.dataset.soieUnitPrice) {
      price.textContent = priceBlock.dataset.soieUnitPrice;
    }
    if (compare) {
      const compareValue = priceBlock.dataset.soieUnitComparePrice || '';
      if (compare.textContent.trim() !== compareValue) compare.textContent = compareValue;
      const group = compare.closest('[role="group"]');
      if (group) group.hidden = !compareValue;
    }
  });
}

let soiePriceLockFrame = 0;
const requestSoiePriceLock = () => {
  if (soiePriceLockFrame) return;
  soiePriceLockFrame = requestAnimationFrame(() => {
    soiePriceLockFrame = 0;
    lockSoieUnitPrice();
  });
};

// SOIE: ignore DOM mutations that originate from inside the <soie-countdown> timer.
// The countdown rewrites its digits' textContent once per second; without this filter,
// that write was tripping the MutationObserver below on every tick and re-running a full
// price-lock scan across the page for no reason, adding constant background main-thread
// work and hurting INP (interaction responsiveness). Any other DOM change still triggers
// the price-lock scan exactly as before.
const isMutationFromCountdown = (node) => {
  if (!node) return false;
  const el = node.nodeType === 1 ? node : node.parentElement;
  return !!el?.closest('soie-countdown');
};

document.addEventListener('DOMContentLoaded', () => {
  refreshBundlerQuantityBreakCache();
  requestSoiePriceLock();
  const productMain = document.querySelector('main') || document.body;
  new MutationObserver((mutations) => {
    const relevant = mutations.some((mutation) => !isMutationFromCountdown(mutation.target));
    if (relevant) requestSoiePriceLock();
  }).observe(productMain, {
    subtree: true,
    childList: true,
    characterData: true
  });
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sb').forEach((bundle) => {
    const buyTwo = bundle.querySelector('[data-soie-bundle-option][data-quantity="2"]');
    if (buyTwo) buyTwo.click();
  });
});

/* SOIE: force the Add to Cart / Buy Now layout with direct inline styles (set with
   'important' priority) instead of relying on the external stylesheet. Shopify's block-level
   styles are emitted inside CSS cascade layers, and per the CSS spec, !important rules inside
   a layer can outrank !important rules in a normal (unlayered) stylesheet -- which is why the
   soie-atc-fix.css rules were being silently overridden no matter how specific they were.
   Inline styles set with priority 'important' always win over ANY stylesheet rule, layered or
   not, so this guarantees the layout actually applies. Runs on every product page load and
   again whenever a section re-renders in the theme editor. Colors, borders, backgrounds and
   click behavior are completely untouched -- only layout/size properties are set here. */
function soieForceAtcLayout(root = document) {
  const rows = root.querySelectorAll
    ? root.querySelectorAll('main[data-template*="product"] .soie-atc-row')
    : [];
  rows.forEach((row) => {
    const set = (el, prop, value) => el && el.style.setProperty(prop, value, 'important');
    set(row, 'display', 'flex');
    set(row, 'flex-direction', 'column');
    set(row, 'align-items', 'stretch');
    set(row, 'gap', '10px');
    set(row, 'width', '100%');
    set(row, 'flex', '1 1 100%');

    Array.prototype.forEach.call(row.children, (child) => {
      set(child, 'width', '100%');
      set(child, 'min-width', '0');
      set(child, 'flex', '0 0 auto');
    });

    const addBtn = row.querySelector('.add-to-cart-button');
    const buyBtn = row.querySelector('.soie-buy-now-button');
    [addBtn, buyBtn].forEach((btn) => {
      if (!btn) return;
      set(btn, 'width', '100%');
      set(btn, 'box-sizing', 'border-box');
      set(btn, 'min-height', '52px');
      set(btn, 'padding-block', '14px');
      set(btn, 'padding-inline', '20px');
      set(btn, 'font-size', '16px');
      set(btn, 'letter-spacing', '0');
      set(btn, 'white-space', 'nowrap');
    });

    row
      .querySelectorAll('.add-to-cart-text, .add-to-cart-text__content, .add-to-cart-text__content span, [data-soie-buy-now-text]')
      .forEach((el) => set(el, 'white-space', 'nowrap'));

    const icon = row.querySelector('.add-to-cart-button .add-to-cart-icon');
    if (icon) set(icon, 'display', 'inline-flex');
  });
}
document.addEventListener('DOMContentLoaded', () => soieForceAtcLayout());
document.addEventListener('shopify:section:load', (event) => soieForceAtcLayout(event.target));
